import api from './client'

export interface DatasetCreate {
  name: string
  session_id?: string
  search_id?: string
  data: Record<string, any>[]
  metadata?: Record<string, any>
}

export interface DatasetResponse {
  dataset_id: string
  user_id: string
  session_id?: string
  search_id?: string
  name: string
  row_count: number
  created_at: string
}

export interface DatasetDetailResponse extends DatasetResponse {
  data: Record<string, any>[]
  metadata?: Record<string, any>
}

export const datasetApi = {
  create: (data: DatasetCreate) => api.post<DatasetResponse>('/datasets', data),
  list: (sessionId?: string) => api.get<DatasetResponse[]>('/datasets', {
    params: sessionId ? { session_id: sessionId } : undefined,
  }),
  get: (id: string) => api.get<DatasetDetailResponse>(`/datasets/${id}`),
  delete: (id: string) => api.delete(`/datasets/${id}`),
}
